import React from 'react';
import { Box, Grid } from '@mui/material';
import { EmojiLoginForm } from '../../../components/auth/LoginForms';
import { iconlogin, loginStars } from '../../../components/assets/images';
import { useNavigate } from 'react-router-dom';
import paths from '../../../routes/paths';

const EmojiLoginPage = () => {
  const navigate = useNavigate();

  const handleBackToOptions = () => {
    navigate(paths.root);
  };

  return (
    <div className="login">
      <Grid container>
        {/* Left sidebar */}
        <Grid item lg={4} md={4} sm={12} xs={12}>
          <div className="brandSidebar">
            <h1 className="welcomeText">
              Welcome to <span>Welbee</span>
            </h1>
            
            <div className="welcomeDescription">
              Systematically measure and improve staff wellbeing
              across your School or Group
            </div>

            <div className="login-icon">
              <img src={iconlogin} alt="" />
            </div>
          </div>        
        </Grid>
        
        {/* Content area - Only showing emoji login */}
        <Grid item lg={8} md={8} sm={12} xs={12}>          
          <div className="contentArea">
            <Grid container justifyContent="center">
              <Grid item lg={11} md={11} sm={10} xs={12}>
                <Box className="slideUpFadeIn">
                  <EmojiLoginForm onBackClick={handleBackToOptions} />
                </Box>
              </Grid>
            </Grid>
          </div>                  
        </Grid>
      </Grid>

      <div className="loginStars">
        <img src={loginStars} alt=""/>
      </div>
    </div>
  );
};

export default EmojiLoginPage;
